"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeHeroClass = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_attackable_sidecar_1 = require("./diveCrew_attackable-sidecar");
var diveCrew_hero_data_1 = require("./diveCrew_hero_data");
var diveCrew_hero_data_sidecar_1 = require("./diveCrew_hero_data-sidecar");
var diveParticles_sidecar_1 = require("@dive/effects/diveParticles-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
function changeHeroClass(obj, heroType, animate, force) {
    if (force === void 0) { force = false; }
    if (obj.heroType === heroType && !force) {
        return;
    }
    assert_sidecar_1.assert.notEq(heroType, diveCrew_hero_data_1.EDiveHeroSubtype.None);
    assert_sidecar_1.assert.notNil(obj.heroState);
    obj.heroType = heroType;
    var classData = diveCrew_hero_data_sidecar_1.diveCrew_hero_data.find(heroType);
    assert_sidecar_1.assert.notNil(classData, 'No class data for hero type: ' + heroType);
    obj.heroState.data = classData;
    obj.weaponState = diveCrew_attackable_sidecar_1.diveCrew_attackable.createWeaponStateForHero(heroType);
    if (animate) {
        // TODO: *poof* effect
        diveParticles_sidecar_1.diveParticles.createMultiple('poof', obj.x, obj.y, 10, diveColors_1.diveColors.pureWhite);
    }
}
exports.changeHeroClass = changeHeroClass;
